import React__default from 'react';
import { ReactComponent as SvgSocialIconsEmail } from '../images/social-icons-email.svg.esm.js';
import { ReactComponent as SvgSocialIconsFacebook } from '../images/social-icons-facebook.svg.esm.js';
import { ReactComponent as SvgSocialIconsLinkedIn } from '../images/social-icons-linkedIn.svg.esm.js';
import { ReactComponent as SvgSocialIconsPrint } from '../images/social-icons-print.svg.esm.js';
import { ReactComponent as SvgSocialIconsTwitter } from '../images/social-icons-twitter.svg.esm.js';
import { ShareOptionTypes } from '../types.esm.js';

// import type {
//   IArticleSocialShareButtons,
//   IShareOption
// } from '../types'

var getShareIcon = function getShareIcon(type) {
  switch (type) {
    case ShareOptionTypes.Facebook:
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(SvgSocialIconsFacebook, null));
    case ShareOptionTypes.Twitter:
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(SvgSocialIconsTwitter, null));
    case ShareOptionTypes.LinkedIn:
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(SvgSocialIconsLinkedIn, null));
    case ShareOptionTypes.Email:
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(SvgSocialIconsEmail, null));
    case ShareOptionTypes.Print:
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(SvgSocialIconsPrint, null));
    default:
      return null;
  }
};
var renderShareButton = function renderShareButton(shareOption) {
  var type = shareOption.type,
    title = shareOption.title,
    defaultUrl = shareOption.defaultUrl;
  return /*#__PURE__*/React__default.createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    className: ShareOptionTypes.Print,
    href: defaultUrl,
    "automation-id": "article-share-link-".concat(type.toLowerCase())
  }, /*#__PURE__*/React__default.createElement("span", {
    title: title
  }, getShareIcon(type)));
};
var renderShareButtons = function renderShareButtons(shareOptions) {
  var elements = [];
  if (shareOptions) {
    shareOptions.forEach(function (shareOption) {
      elements.push(renderShareButton(shareOption));
    });
    return elements;
  } else {
    return undefined;
  }
};
var ArticleSocialShareButtons = function ArticleSocialShareButtons(props) {
  var shareOptions = props.shareOptions;
  return /*#__PURE__*/React__default.createElement("div", {
    "automation-id": "article-social-share-buttons",
    className: "flex gap-[10px]"
  }, renderShareButtons(shareOptions));
};

export { ArticleSocialShareButtons };
//# sourceMappingURL=article-share-options.esm.js.map
